import PropTypes from 'prop-types'
import React from 'react'
import Components from './Types'
import LinkWrapper from '../LinkWrapper/LinkWrapper'
import Output from './Output/Output'
import get from 'lodash-es/get'

export const TYPES = [
  'STRING',
  'SECRET',
  'COLOR',
  'EMAIL',
  'URL',
  'PHONE',
  'INTEGER',
  'CURRENCY',
  'DOUBLE',
  'PERCENT',
  'TEXTAREA',
  'BOOLEAN',
  'RADIO',
  'COMBOBOX',
  'PICKLIST',
  'DATE',
  'TIME',
  'DATETIME',
  'MULTIPICKLIST',
  'ID',
  'IMAGE',
  'REFERENCE',
  'MULTIREFERENCE',
  'POLYREFERENCE',
  'POLYMULTIREFERENCE',
  'RANGE'
]

export default class Field extends React.Component {
  static propTypes = {
    // standard fields
    /**
     * Determines which type of field you want. STRING, BOOLEAN, RADIO, etc.
     */
    type: PropTypes.oneOf(TYPES).isRequired,

    /**
     * Lets you select where your data is coming from
     */
    data: PropTypes.any,
    referenceTo: PropTypes.string,

    /**
     * Field label text
     */
    label: PropTypes.string,

    /**
     * Styles of the fields' label
     */
    labelStyle: PropTypes.string,

    /**
     * Determines if the field is mandatory
     */
    required: PropTypes.bool,

    /**
     * Determines the path of the Field
     */
    fieldPath: PropTypes.string,

    // type of component (input or output)
    /**
     * Determines if the field is read only or editable
     */
    isOutput: PropTypes.bool,

    // list view edition
    /**
     * A function to be invoked on the edit end
     */
    onEditEnd: PropTypes.func,
    fromTable: PropTypes.bool,

    // lookup specific
    /**
     * Allows the user to create a lookup
     */
    lookup: PropTypes.array,
    getLookupName: PropTypes.func,
    getLookup: PropTypes.func,
    isLoad: PropTypes.func,

    // input specific
    /**
     * A function to be invoked when value changes
     */
    onValueChange: PropTypes.func,

    /**
     * Determines if the field is disabled
     */
    disabled: PropTypes.bool,

    // type specific
    showRefLabel: PropTypes.bool, // show (or not) referenceTo label

    /**
     * Determines if the field has HTML format
     */
    isHtmlFormatted: PropTypes.bool,

    /**
     * Determines the field date format
     */
    dateFormat: PropTypes.string,

    /**
     * Determines the field date-time format
     */
    dateTimeFormat: PropTypes.string,

    /**
     * Determines the field number format
     */
    numberFormat: PropTypes.string,

    /**
     * Minimum value for number fields
     */
     minNum: PropTypes.number,

    /**
     * Maximum value for number fields
     */
     maxNum: PropTypes.number,

    /**
     * Holds the picklist values
     */
    picklist: PropTypes.object
  }
  render () {
    const { wrapper, isOutput, type, record, displayAs } = this.props

    let Comp = Components[(type && type.toUpperCase()) || 'STRING']
    if (!Comp) Comp = Components.STRING
    // previewView will have value only if display text is set from the field set
    let previewView
    let display = displayAs && displayAs.length > 0 && displayAs[0]
    if (isOutput && display && display.type) {
      Comp = Components[display.type.toUpperCase()]
      if (!Comp) Comp = Components.STRING
      let val = getDisplayValue(display, record, this.props.fieldPath)
      previewView = <Comp.Output {...this.props} data={val} />
    }
    if (isOutput && record && displayAs) {
      if (Comp.DisplayAs) return <Comp.DisplayAs {...this.props} />
      return <DisplayAs {...this.props} child={previewView} />
    }
    if (!isOutput) return <Comp.Input {...this.props} />
    if (isOutput && wrapper) return <Output {...this.props}><Comp.Output {...this.props} /></Output>
    return <Comp.Output {...this.props} />
  }
}

const getDisplayValue = (display, record, fieldPath) => {
  const { label } = display
  let lab = get(record, label)

  if (label && label.indexOf(fieldPath + '.') === 0) {
    lab = get(record, label.replace(fieldPath + '.', ''))
  }

  return lab
}

const DisplayAs = props => {
  let { fieldPath, record, displayAs, child } = props
  let data = get(record, fieldPath)

  data = Array.prototype.concat(data)

  let cmps = []
  for (let item of data) {
    let dsId = item && item.$ && item.$.dataSourceId
    let display = Array.prototype.concat(displayAs).filter(x => x)
    if (!dsId) display = display[0]
    else display = display.find(d => d.dataSourceId === dsId)

    if (display) {
      let { displayType, linkType, value, label, prefix = '', target } = display
      if (displayType === 'link') {
        let val = get(record, value)
        let lab = get(record, label)

        if (value && value.indexOf(fieldPath + '.') === 0) {
          val = get(item, value.replace(fieldPath + '.', ''))
        }
        if (label && label.indexOf(fieldPath + '.') === 0) {
          lab = get(item, label.replace(fieldPath + '.', ''))
        }
        if (linkType === 'none') cmps.push(lab)
        else {
          const { displayType, linkType, ...linkProps } = display
          cmps.push(<Output key={`${val}--${Math.random(0, 1000)}`} {...props}><LinkWrapper history={props.history || {}} {...linkProps} key={`${val}-${Math.random(0, 1000)}`} style={{ marginRight: '.25em' }} type={linkType} link={prefix + (val != null ? val : '')} target={target}>{child || lab}</LinkWrapper></Output >)
        }
      }
    }
  }
  return cmps
}
